import {useAppStore} from './app.js'

console.log('init')

const store = {
  app: null,
  init() {
    store.app = useAppStore()
  }
}

export {store}
